<div class="content content-fixed content-auth">
    <div class="container">
        <div class="media align-items-stretch justify-content-center ht-100p pos-relative">

            <div class="sign-wrapper mg-lg-l-50 mg-xl-l-60">

                <div class="alert alert-danger" role="alert" *ngIf="isValidToken == false">
                    <h4 class="alert-heading">¡Ups!</h4>
                    <p>
                        Su token de restablecimiento de contraseña no es válido o ha caducado. Verifique que haya hecho clic en el enlace correcto. Si esto aún no funciona, solicite un nuevo vínculo para restablecer la contraseña.
                    </p>
                </div>

                <form class="wd-100p" novalidate *ngIf="isValidToken == true" (ngSubmit)="changePassword()">
                    <h3 class="tx-color-01 mg-b-5">Cambiar contraseña</h3>

                    <div class="alert alert-danger" role="alert" *ngIf="error">
                        {{ error }}
                    </div>

                    <div class="form-group">
                        <label>Nueva contraseña *</label>
                        <input type="password" class="form-control" placeholder="Ingresa tu nueva contraseña" [(ngModel)]="form.Nuevacontrasena" name="Nuevacontrasena">
                    </div>

                    <div class="form-group">
                        <label>Confirmar contraseña *</label>
                        <input type="password" class="form-control" placeholder="Confirmar contraseña" [(ngModel)]="form.ConfirmarNuevacontrasena" name="ConfirmarNuevacontrasena">
                    </div>

                    <button class="btn btn-brand-02 btn-block" type="submit">Actualizar contraseña</button>

                </form>
            </div><!-- sign-wrapper -->

            <div class="media-body align-items-center d-none d-lg-flex mg-lg-l-50 mg-xl-l-60">
                <div class="mx-wd-600">
                    <img src="/assets/img/login_sa_2.png" class="img-fluid" alt="" />
                </div>
            </div>
        </div><!-- media -->
    </div><!-- container -->
</div><!-- content -->